import { module as Module } from 'modujs';

export default class NavSelect extends Module {
    constructor(m) {
        super(m);

        // UI
        this.$select = this.$('select')[0];
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.$select.addEventListener('change', this.onChange);
    }

    unbindEvents() {
        this.$select.removeEventListener('change', this.onChange);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onChange = (e) => {
        this.call('goTo', e.target.value, 'Load');
    };
}
